export default "__VITE_ASSET__Ba6U5Sfy__"